import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@routes/utils";

const baseRoute = `/notification-management`;

export const notificationManagementRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create`,
} as const;

export type INotificationManagementRouteParams = IExtractRouteParamMap<
  typeof notificationManagementRoutesObj
>;

export const notificationManagementPath = createPaths<
  typeof notificationManagementRoutesObj,
  INotificationManagementRouteParams
>(notificationManagementRoutesObj);
